// extracted by mini-css-extract-plugin
module.exports = {"input_flex":"ChipsBox_input_flex__2gyX5","chipFlex":"ChipsBox_chipFlex__1AiT4"};